import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones,  formatoPNG } from './configuracion';

const layer0079 = new TileLayer({
  title: 'Máscara 20160902',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160902l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0079.setVisible(false);
  
const layer0078 = new TileLayer({
  title: 'Máscara 20160910',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160910l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0078.setVisible(false);
  
const layer0077 = new TileLayer({
  title: 'Máscara 20160926',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160926l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0077.setVisible(false);
  
const layer0076 = new TileLayer({
  title: 'Máscara 20161004',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20161004l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0076.setVisible(false);
  
const layer0075 = new TileLayer({
  title: 'Máscara 20161215',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20161215l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0075.setVisible(false);
 
const layer0074 = new TileLayer({
  title: 'Máscara 20161223',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20161223l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0074.setVisible(false);
  
const layer0073 = new TileLayer({
  title: 'Máscara 20161231',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20161231l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0073.setVisible(false);

const layer0072 = new TileLayer({
  title: 'Máscara 20170108',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170108l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0072.setVisible(false);
  
const layer0071 = new TileLayer({
  title: 'Máscara 20170124',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170124l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0071.setVisible(false);
  
const layer0070 = new TileLayer({
  title: 'Máscara 20170217',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170217l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0070.setVisible(false);
  
const layer0069 = new TileLayer({
  title: 'Máscara 20170329',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170329l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0069.setVisible(false);
 
const layer0068 = new TileLayer({
  title: 'Máscara 20170406',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170406l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0068.setVisible(false);
  
const layer0067 = new TileLayer({
  title: 'Máscara 20170508',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170508l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0067.setVisible(false);

const layer0066 = new TileLayer({
  title: 'Máscara 20170524',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170524l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0066.setVisible(false);
  
const layer0065 = new TileLayer({
  title: 'Máscara 20170601',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170601l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0065.setVisible(false);

const layer0064 = new TileLayer({
  title: 'Máscara 20170617',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170617l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0064.setVisible(false);
 
const layer0063 = new TileLayer({
  title: 'Máscara 20170703',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170703l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0063.setVisible(false);
  
const layer0062 = new TileLayer({
  title: 'Máscara 20170711',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170711l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0062.setVisible(false);
  
const layer0061 = new TileLayer({
  title: 'Máscara 20170719',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170719l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0061.setVisible(false);
  
const layer0060 = new TileLayer({
  title: 'Máscara 20170727',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170727l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0060.setVisible(false);
  
const layer0059 = new TileLayer({
  title: 'Máscara 20170804',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170804l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0059.setVisible(false);
  
const layer0058 = new TileLayer({
  title: 'Máscara 20170812',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170812l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0058.setVisible(false);
  
const layer0057 = new TileLayer({
  title: 'Máscara 20170820',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170820l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0057.setVisible(false);

export const grupoCapa01_5 = new LayerGroup({
  title: 'Ciclo Hidrológico 2016-2017',
  fold: 'close',
  layers: [ layer0057, layer0058, layer0059, layer0060, layer0061, layer0062, layer0063, layer0064, layer0065, layer0066, layer0067, layer0068, layer0069, layer0070, layer0071, layer0072, layer0073, layer0074, layer0075, layer0076, layer0077, layer0078, layer0079]
});